import React, { FC } from 'react'
import styles from 'styles/components/card.module.scss'
import HTMLReactParser from 'html-react-parser'
import { returnCodeToBr } from 'lib/helper'
import { Spacer } from 'components/Utility'

type Props = {
  request: string
}

const PrintOrderRequest: FC<Props> = (props) => {
  const { request } = props
  return (
    <div>
      <h3 className={styles.printOrder__request__title}>お客さまからのご要望</h3>
      <Spacer size={4} />
      <p className={styles.printOrder__request__content}>{HTMLReactParser(returnCodeToBr(request))}</p>
    </div>
  )
}

export default PrintOrderRequest
